import styled from "@emotion/styled";
import { useTranslation } from "react-i18next";
import { SectionSmallHeading, SectionText } from "../shared/Section";
import sections from "../shared/sections";

const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1rem;
  width: 100%;
  height: 100%;
  padding: 15vh 5vw 10vh 5vw;
  z-index: 10;
`;

const Text = styled.span`
  display: flex;
  background-color: transparent;
  border: 0;
  color: #fff;
  transition: opacity 200ms;
  opacity: 1;
  cursor: pointer;
  font-size: 1.4rem;
  font-weight: 700;
  text-transform: none;
  span {
    display: inline-block;
    width: 2.6em;
    text-align: left;
    color: ${(props) => props.theme.accentColor};
    transition: transform 200ms;
  }
  &:hover {
    span {
      transform: translateX(0.3em);
    }
  }
`;

const Links = styled.ul`
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  & :nth-child(1) {
    margin-top: auto;
  }
  @media (${(props) => props.theme.breakpoint}) {
    & :nth-child(1) {
      margin-top: 0;
    }
  }
`;

const NavigationText = styled.div`
  @media (${(props) => props.theme.breakpoint}) {
    margin-top: auto;
  }
`;

const Navigation = ({ onClick }) => {
  const { t } = useTranslation();

  const items = sections;

  return (
    <Container>
      <Links>
        {items.slice(0, -1).map((section, index) => (
          <li key={index}>
            <Text as={"button"} onClick={() => onClick(index)}>
              <span>{section.number}</span>
              {t(section.i18nKey)}
            </Text>
          </li>
        ))}
      </Links>
      <NavigationText>
        <SectionSmallHeading>
          {t("Navigation.howItWasMadeTitle")}
        </SectionSmallHeading>
        <SectionText maxWidth="300px">
          {t("Navigation.howItWasMade")}
        </SectionText>
      </NavigationText>
    </Container>
  );
};

export default Navigation;
